import { useContext, useMemo } from 'react'
import { Row, Col } from '@leroy-merlin-br/backyard-react-ui'

import { Sorters } from '../Sorters'
import { EntryKeyContext } from '../../context/EntryKeyContext'
import { Space } from '../Space'
import * as S from './styled'

const SortersBar = () => {
  const {
    metadata: { totalCount }
  } = useContext(EntryKeyContext)

  const productsTotal = useMemo(() => {
    const label = totalCount === 1 ? 'Produto' : 'Produtos'
    const value = totalCount?.toLocaleString('pt-BR')

    return { label, value }
  }, [totalCount])

  return (
    <S.SortersBar>
      <Row align="center">
        <Col size={{ giga: 3 }}>
          <Space right={false}>
            <S.Title as="h2" size="mega" noMargin>
              Refinar busca
            </S.Title>
          </Space>
        </Col>

        <Col size={{ giga: 9 }}>
          <Space left={false}>
            <S.Wrapper>
              <S.Label>
                <S.Count>{productsTotal.value}</S.Count>
                {productsTotal.label}
              </S.Label>

              <S.Divider />

              <S.Label>
                Ordenar por
              </S.Label>

              <Sorters />
            </S.Wrapper>
          </Space>
        </Col>
      </Row>
    </S.SortersBar>
  )
}

export default SortersBar
